import { render, staticRenderFns } from "./ReceiveCar.vue?vue&type=template&id=b2a254f8&scoped=true"
import script from "./ReceiveCar.vue?vue&type=script&lang=js"
export * from "./ReceiveCar.vue?vue&type=script&lang=js"
import style0 from "./ReceiveCar.vue?vue&type=style&index=0&id=b2a254f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a254f8",
  null
  
)

export default component.exports